import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { themes, Dialog } from 'libs/ui';
import { DictFilter } from 'libs/form';
import { Content } from './status-set-form.styled';

const StatusSetFormForm = (props) => {
  const { dict, handleSubmit, invalid, dictExclude, dict_force_name, working } = props;
  const { t } = useTranslation();

  /**
   * make action
   * @param {*} event
   */
  const submit = (values) => {
    return props.action(values);
  };

  return (
    <Dialog
      // w={450}
      id="dialog-status-set-form"
      title={'Изменить статус у выбранных записей'}
      align="justify"
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: handleSubmit(submit), theme: themes.blue, disabled: working | invalid, working },
      ]}
    >
      <Content>
        <form onSubmit={handleSubmit(submit)}>
          <DictFilter simpleErrorWrapper w={200} withEmpty emptyName={t('payment_method.Выберите значение')} name="status" force_name={dict_force_name} dict={dict} exclude={dictExclude} required />
        </form>
      </Content>
    </Dialog>
  );
};

export const StatusSetForm = reduxForm({
  form: 'soStatusSet',
  destroyOnUnmount: true,
  // initialValues: initial,
})(StatusSetFormForm);
